interface IPhasesCO2 {
	readonly a1: number;
	readonly a2: number;
	readonly a3: number;
	readonly a4: number;
	readonly a5: number;
	readonly c1: number;
	readonly c2: number;
	readonly c3: number;
	readonly c4: number;
	readonly d: number;
}

export default class PhasesCO2 implements IPhasesCO2 {
	public get a1(): number {
		return this.#a1;
	}

	public get a2(): number {
		return this.#a2;
	}

	public get a3(): number {
		return this.#a3;
	}

	public get a4(): number {
		return this.#a4;
	}

	public get a5(): number {
		return this.#a5;
	}

	public get c1(): number {
		return this.#c1;
	}

	public get c2(): number {
		return this.#c2;
	}

	public get c3(): number {
		return this.#c3;
	}

	public get c4(): number {
		return this.#c4;
	}

	public get d(): number {
		return this.#d;
	}

	#a1: number;
	#a2: number;
	#a3: number;
	#a4: number;
	#a5: number;
	#c1: number;
	#c2: number;
	#c3: number;
	#c4: number;
	#d: number;
	public constructor({ a1, a2, a3, a4, a5, c1, c2, c3, c4, d }: IPhasesCO2) {
		this.#a1 = a1;
		this.#a2 = a2;
		this.#a3 = a3;
		this.#a4 = a4;
		this.#a5 = a5;
		this.#c1 = c1;
		this.#c2 = c2;
		this.#c3 = c3;
		this.#c4 = c4;
		this.#d = d;
	}
}
